import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { inject, observer } from 'mobx-react';
import gsap from 'gsap';
import styles from './index.module.less';
import { GlobalTracker } from '@/utils/Tracker';
import { ICON } from '@/utils/configs/static.config';

/**
 * @param {boolean} disabled 弹窗时不应该唤起气泡
 * @param {(from:string)=>{}} onShow from='hover'不展示关闭按钮
 * @param {(from:string)=>{}} onHide from='hover'只有hover触发的展示才能关闭hover触发的关闭
 */
const Index = forwardRef((props, ref) => {
  const { tracker, disabled = false } = props;
  const {
    LANG,
    country: { code, language },
  } = props.area;
  const popoverRef = useRef(null);
  const [from, setFrom] = useState('');
  const [visible, setVisible] = useState(false);
  const TIME = 10; // 延迟10s 展示
  const FADE_TIME = 18; // 延迟18s 关闭
  const autoShowTimer = useRef(null);

  const onShow = (_from) => {
    // 正在展示的气泡、再次hover不会触发
    if (!visible && !disabled) {
      setFrom(_from);
      setVisible(true);
      clearTimeout(autoShowTimer.current);
      fadeIn();
      GlobalTracker.CustomService({
        action: `${tracker}_bubble_popUp_expose`,
        label: `${code}_${language}_${from === 'hover' ? 'hover' : 'auto'}_popUp_${window.location.pathname}`,
      });
    }
  };

  const onClose = () => {
    setVisible(false);
    fadeOut();
  };

  // 外部暴露的关闭方法，只有from对应上才能正确关闭
  const onHide = (_from) => {
    if (from === _from) {
      onClose();
    }
  };

  useImperativeHandle(ref, () => ({
    onShow,
    onHide,
  }));

  // 淡入
  const fadeIn = () => {
    gsap.to(popoverRef.current, {
      duration: 0.3,
      xPercent: 0,
      opacity: 1,
      ease: 'power2.in',
      onStart: () => {
        gsap.set(popoverRef.current, {
          display: 'block',
        });
      },
    });
  };

  // 淡出
  const fadeOut = () => {
    gsap.to(popoverRef.current, {
      duration: 0.3,
      xPercent: 10,
      opacity: 0,
      ease: 'power2.out',
      onComplete: () => {
        !visible && gsap.set(popoverRef.current, { display: 'none' });
      },
    });
  };

  useEffect(() => {
    // 进入页面后计算渲染的宽度，然后设置为浮动定位，否则icon的高度会被错误撑起，不设置seiTimeout高度不正确
    if (popoverRef.current) {
      gsap.set(popoverRef.current, {
        position: 'absolute',
        left: `-${popoverRef.current?.offsetWidth + 8}px`,
        bottom: 0,
      });
    }

    // 会话内只触发一次
    if (!window.sessionStorage.getItem('intercom_popover_show')) {
      // 进入页面后10s弹出,5s后收起，如果有其他操作将取消这个收起操作。
      autoShowTimer.current = setTimeout(() => {
        window.sessionStorage.setItem('intercom_popover_show', 1);
        onShow();
      }, TIME * 1000);

      setTimeout(() => {
        onClose();
      }, FADE_TIME * 1000);
    }
  }, []);

  const clickClose = () => {
    onClose();
    fadeOut();
    GlobalTracker.CustomService({
      action: `${tracker}_bubble_close_click`,
      label: `${code}_${language}__${window.location.pathname}`,
    });
  };

  return (
    <div className={styles.popover} ref={popoverRef} data-from={from}>
      {LANG['common.tips.consult_tip']}
      <div className={styles.close} onClick={clickClose}>
        <img className={styles.img} src={ICON.close} alt='' />
      </div>
      <img
        className={styles.icon}
        width={20}
        height={20}
        src='https://res.insta360.com/static/09e3b94fe41c54a1683b5d7bee6a5313/icon.png'
        alt=''
      />
    </div>
  );
});

Index.displayName = 'ContactPopupTip';

const ContactPopupTip = inject('area', 'app')(observer(Index));
export default ContactPopupTip;
